var React = require('react');

function Reset (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.765 19.616a8.978 8.978 0 01-2.77 1.644 9.003 9.003 0 01-3.17.572 8.893 8.893 0 01-4.578-1.235 9.195 9.195 0 01-3.27-3.27 8.893 8.893 0 01-1.235-4.577c0-1.647.412-3.173 1.235-4.578a9.195 9.195 0 013.27-3.27 8.893 8.893 0 014.578-1.235c1.647 0 3.173.412 4.578 1.235a9.195 9.195 0 013.27 3.27 8.894 8.894 0 011.235 4.578c0 .957-.146 1.883-.437 2.78a9.11 9.11 0 01-1.198 2.433l-2.907-5.213h2.725a7.107 7.107 0 00-.745-3.206 7.297 7.297 0 00-2.07-2.534 7.155 7.155 0 00-2.998-1.38 7.052 7.052 0 00-3.297.09c-1.084.29-2.05.8-2.897 1.526A7.166 7.166 0 006.14 9.907a7.068 7.068 0 00-.572 3.242 7.36 7.36 0 00.908 3.143 7.075 7.075 0 002.216 2.443 7.094 7.094 0 003.07 1.208 7.337 7.337 0 003.26-.263A7.134 7.134 0 0017.858 18l.908 1.616z","fill":"#53585F"}));
}

Reset.defaultProps = {"fill":"none","viewBox":"0 0 25 25"};

module.exports = Reset;

Reset.default = Reset;
